import { useQuery } from '@tanstack/react-query';

import Constants from '@/constants';

import {
  AssignableCourseResult,
  ComplianceCourseEnrollmentEntity,
} from '@/_generated/api-clients/xp';
import { getUsersForLocationsOptions } from '@/_generated/api-clients/xp';

export const useTeamMemberCount = (
  locationsWithAtLeastTrainer: string[],
  enrollments: Record<string, ComplianceCourseEnrollmentEntity> = {},
): number => {
  const { data: teamMembers } = useQuery({
    ...getUsersForLocationsOptions({
      query: { locationNumbers: locationsWithAtLeastTrainer },
    }),
    enabled: locationsWithAtLeastTrainer.length > 0,
  });

  const teamMembersDeduped = Array.from(
    new Set(teamMembers?.map(teamMember => teamMember.adId)),
  )
    .map(adId => teamMembers?.find(teamMember => teamMember.adId === adId))
    .filter(member => member != null);

  const teamMembersVisible = teamMembersDeduped.filter(teamMember => {
    const enrollment = enrollments[teamMember.adId ?? ''];
    if (!enrollment) {
      return true;
    }
    return !enrollment.hidden;
  });

  return teamMembersVisible.length;
};

export const enrollmentPassed = (
  enrollment: ComplianceCourseEnrollmentEntity,
) =>
  enrollment.status === Constants.LEARN_UPON_TRAINING_PLANS.COMPLETED ||
  enrollment.status === Constants.LEARN_UPON_TRAINING_PLANS.PASSED;

export type NonNullComplianceCourse = {
  [Property in keyof AssignableCourseResult]-?: AssignableCourseResult[Property];
};
